import React from 'react'
import { Box, TextField, TextFieldProps, Typography } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/styles'
import { StatusTooltip } from '~/components'
import { mutualTheme } from '~/utils/theme'
import clsx from 'clsx'
import { InputSubtitle } from '../InputSubtitle'
import { FieldError } from 'react-hook-form'

const TextFieldCustomCSS = withStyles({
  root: {
    '& label.Mui-focused': {
      color: mutualTheme.palette.secondary.main
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: mutualTheme.palette.secondary.main
      },
      '&.Mui-focused fieldset': {
        borderColor: mutualTheme.palette.secondary.main
      }
    }
  }
})(TextField)

const useStyles = makeStyles({
  label: {
    marginBottom: mutualTheme.spacing(0.5),
    color: mutualTheme.palette.textGray1.main
  },
  input: {
    '&::placeholder': {
      fontFamily: 'Airbnb'
    }
  },
  container: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  subTitle: {
    marginTop: mutualTheme.spacing(0.5)
  },
  selectErrorIcon: {
    marginRight: mutualTheme.spacing(3)
  }
})

export type TextInputProps = TextFieldProps & {
  subtitle?: string,
  useNewFont?: boolean,
  outsideLabel?: boolean,
  containerClassName?: string,
  errorMessage?: string | null | FieldError,
  shrink?: boolean
}

export const TextInput = React.forwardRef<HTMLDivElement, TextInputProps>((props, ref) => {
  const { errorMessage = '', outsideLabel, containerClassName, subtitle, select, ...otherProps } = props
  const classes = useStyles()
  const errorAdornment = errorMessage && {
    endAdornment: (
      <Box className={clsx({ [classes.selectErrorIcon]: select })}>
        <StatusTooltip
          title={errorMessage}
          iconColor={mutualTheme.palette.error.main}
        />
      </Box>
    )
  }

  return (
    <Box className={clsx([classes.container, containerClassName])}>
      {outsideLabel && <Typography variant='airbnbBody2' className={classes.label}>{props.label}</Typography>}
      <TextFieldCustomCSS
        {...otherProps}
        fullWidth
        ref={ref}
        variant='outlined'
        label={!outsideLabel && props.label}
        select={select}
        helperText={errorMessage || ''}
        InputLabelProps={{
          shrink: true,
          style: {
            fontFamily: 'Airbnb',
            fontWeight: mutualTheme.typography.fontWeightMedium
          }
        }}
        InputProps={{
          ...props.InputProps,
          ...errorAdornment,
          classes: { input: classes.input }
        }}
      />
      {subtitle && <InputSubtitle className={classes.subTitle} text={subtitle} />}
    </Box>
  )
})
